<template>
<div class="chapter">
<div class="inner_page">
<p class="h2f" id="fm1"><a id="page_4"></a>Acknowledgements</p>
<p class="bodytext-ts">This author thanks those who have provided inspiration and opportunity through the years. That puts my parents, Robert and Adrean Bailey, at the top of the list. My brilliant, beautiful daughters, Shelby and Sydney, compel me to keep moving forward through despair and dismal times.</p>
<p class="bodytext-ts">This author thanks through other literary soldiers who, with pens in hand, slashed through the world, trying to make sense of and beautify it at the same time. My literary crush, Toni Morrison, raises the literary fiction intellectual bar for me with her tender prose. Plenty of others have prettied up the path for me, and I silently tip my hat to them.</p>
<p class="bodytext-ts">This author thanks her Soror Victoria Christopher Murray for the years of sisterhood and full Delta Author on Tour memories, and her sister of the pen, ReShonda Tate Billingsley for taking a literary leap in publishing my first baby in years.</p>
<p class="bodytext-ts">This author thanks her friends and readers for continuing to turn the pages on her work.</p>
<p class="bodytext-ts">Sawubona.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?d6ef3422